import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import THEME from '../../../../../constants/theme';

export const AddButton = styled(Button)`
  border: 1px solid ${THEME.primary} !important;
  border-radius: 8px !important;
  color: ${THEME.primary} !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.14 !important;
  letter-spacing: 1.5px !important;
`;

export const Container = styled.div`
  padding: 30px 25px 20px 50px;
`;
